/**
 * @generated SignedSource<<cf3ff997b9fd0e031518e7ef71dd7377>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModuleBanner_browseContentModule$data = {
  readonly description: string | null;
  readonly link: string | null;
  readonly linkText: string | null;
  readonly photo: string | null;
  readonly subtitle: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "SbSharedContentModuleBanner_browseContentModule";
};
export type SbSharedContentModuleBanner_browseContentModule$key = {
  readonly " $data"?: SbSharedContentModuleBanner_browseContentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedContentModuleBanner_browseContentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedContentModuleBanner_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "photo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "link",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkText",
      "storageKey": null
    }
  ],
  "type": "ContentModuleBanner",
  "abstractKey": null
};

(node as any).hash = "721f11291a4c2bda1bf806b3ed653b1b";

export default node;
